module.exports = __webpack_public_path__ + "static/carbon-file-default-2eafeb6dbd1e93fce49dd968c797b6d0.png";